import react, { useEffect, useState } from "react";
import { Box, Paper, Grid, Button, TextField } from "@mui/material";

export default function X() {
  return (
    <>
      <div>
        <img
          src="https://steamserver2.freemyip.com/uploads/EclipseMy_Event/logo/registerDesc1.png"
          width="100%"
        />
      </div>
    </>
  );
}
